import moment from 'moment';

const SCHEDULE_DATE_NO_TIME_NAME = 'scheduleDateForm';
const SCHEDULE_PASS_NAME = 'schedulePassForm';

const validate = (values, props) => {
  const errors = {};

  const { isAccommodationBooking, productData } = props;

  if (!isAccommodationBooking) {
    const scheduleType = productData.scheduleType;
    if (
      scheduleType === SCHEDULE_DATE_NO_TIME_NAME &&
      (!values.multiDates || !values.multiDates.startDate)
    ) {
      errors.multiDates = 'Starting date is required';
    } else if (scheduleType !== SCHEDULE_PASS_NAME && !values.startingDate) {
      errors.startingDate = 'Starting date is required';
    }
  } else {
    if (!values.dates || !values.dates.startDate || !values.dates.endDate) {
      errors.dates = 'Dates are required';
    } else if (
      moment(values.dates.endDate).diff(values.dates.startDate, 'days') <
      values.minNights
    ) {
      errors.dates = {
        text: 'The number of nights cannot be less than',
        variables: { number: values.minNights }
      };
    }
  }

  if (values.participants && values.participants.length) {
    let participantsArrayErrors = [];
    let isValidParticipants = false;

    values.participants.forEach((item, index) => {
      if (item.participants && parseInt(item.participants) > 0) {
        isValidParticipants = true;
      }

      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (!isValidParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: 'Value for at least one category should be filled in'
      };
    }
  }

  if (
    !errors.participants &&
    values.participants &&
    values.participants.length
  ) {
    const availableParticipants = values.startTime
      ? values.startTime.seatsLeft
      : values.maxParticipants;
    const participantsArrayErrors = [];
    let totalParticipants = 0;

    values.participants.forEach((item, index) => {
      if (item.participants && item.participants.length) {
        totalParticipants += parseInt(item.participants);
      }
      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (totalParticipants > availableParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: `The number of Guests can’t exceed ${availableParticipants}`
      };
    } else if (
      productData.generalForm?.minParticipants && totalParticipants < Number(productData.generalForm.minParticipants)
    ) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: `The number of Guests can’t be less than ${productData.generalForm.minParticipants}`
      };
    }
  }

  return errors;
};

export default validate;
